<template>
    <div class="grid--con">
        <div v-if="faqDtlAt == 'N'">
            <div class="faq-search mgb30">
                <div class="box-type04"><input type="text" placeholder="무엇을 도와드릴까요?" v-model="searchTxt" @keyup.enter="searchSearchList()"/></div>
                <button @click="searchSearchList()"><div class="img-com _bt-ic06"><span>FAQ 검색 버튼 아이콘</span></div></button>
            </div>
            <div class="tab-common">
                <ul class="tabmenu __grid--tab5">
                    <li :class="clCd == null? 'current' : ''" @click="moveFaqTab()"><a href="javascript:;">전체</a></li>
                    <li :class="clCd == 'G01'? 'current' : ''" @click="moveFaqTab('G01')"><a href="javascript:;">회원관리</a></li>
                    <li :class="clCd == 'G02'? 'current' : ''" @click="moveFaqTab('G02')"><a href="javascript:;">결제/환불</a></li>
                    <li :class="clCd == 'G03'? 'current' : ''" @click="moveFaqTab('G03')"><a href="javascript:;">서비스 이용</a></li>
                    <li :class="clCd == 'G04'? 'current' : ''" @click="moveFaqTab('G04')"><a href="javascript:;">문서서식</a></li>
                </ul>
                <div class="tab-container">
                    <div class="tab-content" id="tab-1" style="display:;">
                        <div class="board-number-cases mgt30" v-html="listCntMsg"></div>
                        <div class="board-list mgt10">
                            <ul>
                                <li v-for="(faqInfo,index) in faqList"
                                    :key="'faq'+index"
                                    @click="searchFaqDetail(faqInfo.qestn, faqInfo.answer)">
                                    <a href="javascript:;">
                                        <div class="board-tit-con">
                                            <div class="entry-title" v-html="faqInfo.qestn"></div>
                                        </div>
                                    </a>
                                </li>
                                <li v-if="faqList.length == 0">
                                    <div style="padding: 20px;text-align: center;">조회된 내역이 없습니다.</div>
                                </li>

                            </ul>
                        </div>
                        <pagenavi :paginginfo="paginginfo" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="faqDtlAt == 'Y'">
            <div class="board-view box-type01 mgt20">
                <div class="section-title">
                    <div class="board-tit-con">
                        <div class="entry-title" v-html="faqDtlQestn"></div>
                    </div>
                </div>
                <div class="board-view-con" v-html="faqDtlAnswer"></div>
            </div>
            <div class="btn-wrap __right mgt20">
                <button class="middle _bt-ypurple" @click="faqDtlAt = 'N'"><span>목록으로</span></button>
            </div>
        </div>
        <!--<div class="bn-common-type01 mgb20">
            <ul>
                <li>
                    <div class="box-type05">
                        <div class="faq-bn">
                            <button @click="menualDownClick('001')">원장님 매뉴얼<div class="img-com _bt-ic07"><span>FAQ 검색 버튼 아이콘</span></div></button>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="box-type05">
                        <div class="faq-bn">
                            <button @click="menualDownClick('002')">선생님 매뉴얼<div class="img-com _bt-ic07"><span>FAQ 검색 버튼 아이콘</span></div></button>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="box-type05" style="width:808px;">
                        <div class="faq-bn">
                            <div class="f-left">
                                <div class="faq-bn-txt faq-bn-bg01">
                                    <div class="entry-title">원하는 답변이 없으신가요?</div>
                                    <div class="entry-txt">문의사항을 1:1문의에 남겨주세요. <span>신속하게 답변</span>드리겠습니다.</div>
                                </div>
                            </div>
                            <div class="f-right">
                                <button @click="moveQstn()">1:1 문의하러 가기<div class="img-com _bt-ic07"><span>FAQ 검색 버튼 아이콘</span></div></button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "faq_popup",
        props:['params'],
        data: function(){
            return {
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 5, /* 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지당 게시물수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFunc:null
                },
                url : '',
                listCntMsg : '',
                faqDtlAt : '',
                faqList : new Array(),
                searchTxt : null,
                clCd : null,
                faqDtlQestn : null,
                faqDtlAnswer : null
            }
        },
        methods : {
            searchFaqList : function(){
                const _this = this;
                
                this.axios.post(this.url + '/cs/faq/searchFaqList.act',{
                    pagingInfo : {
                        clCd : this.clCd,
                        searchTxt : this.searchTxt,
                        curPageNum : this.paginginfo.curPageNum,
                        startCnt : ((this.paginginfo.curPageNum-1) * this.paginginfo.pageListCnt)+1,
                        endCnt : this.paginginfo.curPageNum * this.paginginfo.pageListCnt
                    }
                }).then(function(response) {
                    this.faqDtlAt = 'N';
                    this.faqList = response.data.faqInfo.faqList;
                    this.paginginfo.totCnt = response.data.faqInfo.pagingInfo.totCnt;
                    this.paginginfo.curPageNum = response.data.faqInfo.pagingInfo.curPageNum;

                    if(this.searchTxt == null || this.searchTxt == ''){
                        this.listCntMsg = '전체 <span>'+this.paginginfo.totCnt+'</span>건';

                    }else {
                        this.listCntMsg = '<span>'+this.searchTxt+'</span> 검색결과 <span>'+this.paginginfo.totCnt+'</span>건';

                        for(var i=0; i<this.faqList.length; i++){
                            this.faqList[i].qestn = this.faqList[i].qestn.replace(this.searchTxt, '<span class="bg01">'+this.searchTxt+'</span>');
                        }
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            moveFaqTab : function(clCd){
                this.clCd = clCd;
                this.paginginfo.curPageNum = 1;
                this.searchTxt = null;
                this.searchFaqList();
            },
            searchSearchList : function(){
                this.paginginfo.curPageNum = 1;
                this.searchFaqList();
            },
            searchFaqDetail : function(qestn, answer){
                this.faqDtlAt = 'Y';
                if(qestn.indexOf('<span class="bg01">') != -1){
                    qestn = qestn.replace('<span class="bg01">'+this.searchTxt+'</span>', this.searchTxt);
                }
                this.faqDtlQestn = qestn;
                this.faqDtlAnswer = answer;
            },
            moveQstn : function(){
                /*var param = {qstnSe : 'write'};*/
                /*popup.modalCreate("qstnPopup","1220","","/works/cs/qstn/qstn.on","1:1문의",false, param);
                popup.close('faqPopup');*/
            },
            menualDownClick: function(downSe){
                if(downSe == '001'){
                    alert('준비중입니다.');
                }else if(downSe == '002'){
                    alert('준비중입니다.');
                }
            }
        },
        mounted:function(){
            this.paginginfo.callBackFunc = this.searchFaqList;
            
            const url = document.location.href;

            if(url.indexOf('/works') > -1){
                this.url = '/works';
            }else{
                this.url = '/cloud';
            }

            this.searchFaqList();
        }
    }
</script>

<style scoped>

</style>